import { RootState } from 'src/store/rootReducer'

export const getDashboardTypeList = ({
  DashboardType,
}: RootState): UncDashboard.Dashboard[] => {
  return DashboardType.dashboardTypes || []
}
